<template>
  <div class="Dashboards" id="Dashboards">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <div class="Dashboards-title">
          <el-select v-model="boardName" filterable placeholder="请选择" @change="dashboardChange">
            <el-option-group
              v-for="group in dashboardDataOption"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item._id"
                :label="item.boardName"
                :value="item._id"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
        <!-- -
        <el-popover placement="bottom-start" trigger="click" style="padding-top: 0;">
          <div class="search-wrapper">
            <div>
              <el-select v-model="boardName" filterable clearable placeholder="请选择">
                <el-option-group
                  v-for="group in dashboardData"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item._id"
                    :label="item.boardName"
                    :value="item._id"
                  ></el-option>
                </el-option-group>
              </el-select>
            </div>
          </div>
          <el-button type="text" slot="reference">
            <h3 style="font-size:17px">
              {{ boardNameShow ? boardNameShow : "报表看板" }}
              <i
                class="el-icon-arrow-down el-icon--right"
              ></i>
            </h3>
          </el-button>
        </el-popover>
        -->
        <span class="f-s-14 c-m-l-15"></span>
      </div>
      <div class="c-flex">
        <el-button type="primary" @click="openDetail = true" class="c-m-l-10">新增看板</el-button>
        <el-dropdown class="c-m-l-10" @command="commandClick">
          <el-button type="primary">
            操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit">编辑看板</el-dropdown-item>
            <el-dropdown-item command="copy">克隆当前看板</el-dropdown-item>
            <el-dropdown-item command="delete">删除当前看板</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" @click="$router.push({ path: '/Reports' })" class="c-m-l-10">
          新增指标块
        </el-button>
      </div>
    </div>
    <div class="reports">
      <!-- <div class="filter-wrapper"> -->
      <!--  <el-popover placement="bottom-start" trigger="click" style="padding-top: 0;">
          <div class="filter-inner">
            <div class="demonstration">日期选择</div>
             <el-date-picker
              v-model="globalDate"
              type="daterange"
              align="right"
              width="100%s"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
          <el-button type="text" slot="reference">
            <span class="el-dropdown-link isHover-link">
              <i class="el-icon-s-operation" style="font-size:15px"></i>
              <b style="margin-left:4px;font-size:14px">筛选指标块</b>
            </span>
          </el-button>
        </el-popover>-->
      <!-- <div class="filter-inner">
          <div
            class="el-dropdown-link isHover-link"
            style="display:flex;align-items: center;width: 120px;"
          >
            <i class="el-icon-s-operation" style="font-size:15px"></i>
            <b style="margin-left:4px;font-size:14px">全局筛选时间</b>
          </div>
          <el-date-picker
            style="width:280px"
            v-model="globalDate"
            type="daterange"
            align="right"
            width="100%s"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="renderCharts(layout)"
          ></el-date-picker>
        </div> -->
      <!-- </div> -->
      <grid-layout
        :layout.sync="layout"
        :col-num="2"
        :row-height="500"
        :is-draggable="true"
        :is-resizable="true"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[20, 20]"
        :use-css-transforms="true"
        :responsive="false"
        @layout-updated="layoutUpdatedEvent"
        :cols="{ lg: 2, md: 2, sm: 2, xs: 1, xxs: 1 }"
      >
        <grid-item
          v-for="item in layout"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :key="item.i"
          @resized="layoutMoved"
          @moved="layoutMoved"
        >
          <div class="iBlock">
            <div class="iBlock-head">
              <div class="iBlock-head-title">
                <div>
                  {{ item.report.title }}
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.report.description"
                    placement="right"
                  >
                    <i class="el-icon-info" style="font-size: 14px"></i>
                  </el-tooltip>
                </div>
                <el-dropdown class="dropdown-block" @command="commandBlockClick">
                  <span class="el-dropdown-link" style="cursor: pointer">
                    操作指标块
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{ val: 'BlockEdit', data: item }">
                      编辑指标块
                    </el-dropdown-item>
                    <el-dropdown-item :command="{ val: 'BlockRemove', data: item }">
                      从看板删除
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="iBlock-head-filter">
                <div style="font-size: 16px">
                  <div v-if="item.report.config && noteShowValue(item.report.config)">
                    过滤条件：
                    {{ noteShowValue(item.report.config) }}
                  </div>
                  <div v-if="item.report.filterCondition" style="margin-top: 6px">
                    日期范围： {{ item.report.filterCondition | dateRange }}
                  </div>
                </div>
                <!-- v-if="item.report.reportType != 'table'" -->
                <el-button type="text" @click="setting(item)">
                  <span class="el-dropdown-link isHover-link">
                    <!-- <b >设定</b> -->
                    <i style="margin-left: 4px; font-size: 24px" class="el-icon-s-operation"></i>
                  </span>
                </el-button>
              </div>
            </div>
            <div class="iBlock-contents">
              <div
                class="flex-1"
                :id="item.report._id"
                :ref="item.report._id"
                style="width: 100%; height: 100%"
              >
                <div
                  v-if="item.report.htmlPart"
                  v-html="item.report.html"
                  class="report-html"
                ></div>
                <cReportLit
                  :reportData="item.report"
                  v-if="item.report.reportType == 'table'"
                ></cReportLit>
              </div>
            </div>
          </div>
        </grid-item>
      </grid-layout>
    </div>
    <el-dialog
      :title="formDataBlock.reportType == 'table' ? '设定预览' : '时间设定'"
      :visible.sync="openDateDetail"
      id="reportSettingsPreview"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="display: flex">
        <div style="flex: 1; width: 100%">
          <div class="c-flex" style="height: 600px" v-if="formDataBlock.reportType == 'table'">
            <div style="width: 100%">
              <cReportLit :reportData="formDataBlock" :isShowFilter="true" ref="cReportLit">
                <template slot="filterLeft">
                  <el-form
                    :model="formDateData"
                    :rules="rules"
                    ref="formDateData"
                    label-width="70px"
                    label-position="left"
                    hide-required-asterisk
                    v-if="formDateData.filterCondition"
                  >
                    <el-form-item label="时间范围">
                      <el-select
                        v-model="formDateData.filterCondition.date.type"
                        placeholder="请选择日期范围"
                        @change="reportDateChange"
                      >
                        <el-option
                          v-for="item in options.dateRangeType"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="自定义范围"
                      v-if="formDateData.filterCondition.date.type == 'custom'"
                    >
                      <el-date-picker
                        v-model="formDateData.filterCondition.date.range"
                        type="daterange"
                        align="right"
                        width="100%s"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                      ></el-date-picker>
                    </el-form-item>
                  </el-form>
                </template>
                <template slot="filterRight">
                  <p style="font-size: 24px; height: 50px; line-height: 50px">
                    {{ formDataBlock.title }}
                  </p>
                  <p>{{ formDataBlock.description }}</p>
                </template>
              </cReportLit>
            </div>
          </div>
          <div v-else>
            <el-form
              :model="formDateData"
              :rules="rules"
              ref="formDateData"
              label-width="110px"
              label-position="left"
              hide-required-asterisk
              v-if="formDateData.filterCondition"
            >
              <el-form-item label="时间范围">
                <el-select
                  v-model="formDateData.filterCondition.date.type"
                  placeholder="请选择日期范围"
                >
                  <el-option
                    v-for="item in options.dateRangeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="自定义范围"
                v-if="formDateData.filterCondition.date.type == 'custom'"
              >
                <el-date-picker
                  v-model="formDateData.filterCondition.date.range"
                  type="daterange"
                  align="right"
                  width="100%s"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="doDataSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="看板信息" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="110px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="看板名称" prop="boardName">
          <el-input v-model="formData.boardName" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="看板描述" prop="describe">
          <el-input v-model="formData.describe" placeholder="请输入描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          @click="
            doSave().then(() => {
              osg.toast('保存成功');
            })
          "
        >
          确 定
        </el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="指标块信息" :visible.sync="openBlockDetail">
      <el-form
        v-if="formDataBlock.report"
        :model="formDataBlock.report"
        :rules="rules"
        ref="formDataBlock"
        label-width="110px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="指标块标题" prop="title">
          <el-input v-model="formDataBlock.report.title" placeholder="请输入名称"></el-input>
        </el-form-item>
        <!--
        <el-form-item label="指标块名称描述" prop="description">
          <el-input
            type="textarea"
            placeholder="请输入描述"
            :rows="4"
            v-model="formDataBlock.report.description"
          ></el-input>
        </el-form-item>
        -->
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doBlockSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueGridLayout from 'vue-grid-layout';
import cReportLit from '../../components/reportList.vue';
let echarts = require('echarts');
export default {
  activated() {
    window.$this = this;
  },
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    cReportLit
  },
  inject: ['viewReload'], //注入nav里的viewReload方法
  data() {
    return {
      chart: echarts,
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      layout: [
        // { x: "", y: 0, w: 1, h: 1, i: "0", report: { haha: "哈哈", id: "1" } }
        // { x: 0, y: 0, w: 1, h: 1, i: "1", report: { haha: "哈哈", id: "1" } },
        // { x: 0, y: 0, w: 1, h: 1, i: "2", report: { haha: "哈哈", id: "1" } },
        // { x: 0, y: 0, w: 1, h: 1, i: "3", report: { haha: "哈哈", id: "1" } },
        // { x: 1, y: 0, w: 1, h: 1, i: "1", report: { haha: "哈哈", id: "2" } },
        // { x: 0, y: 1, w: 1, h: 1, i: "2", report: { haha: "哈哈", id: "3" } },
        // { x: 1, y: 1, w: 1, h: 1, i: "3", report: { haha: "哈哈", id: "4" } }
      ],
      searchValue: '',
      globalDate: [],
      option: [],
      optionsDate: [
        {
          label: '最近搜索',
          options: [
            {
              value: 'Shanghai',
              label: '上海'
            },
            {
              value: 'Beijing',
              label: '北京'
            }
          ]
        },
        {
          label: '城市名',
          options: [
            {
              value: 'Shanghai',
              label: '上海'
            },
            {
              value: 'Beijing',
              label: '北京'
            },
            {
              value: 'Dalian',
              label: '大连'
            }
          ]
        }
      ],
      //看板数据
      dashboardData: [],
      //看板标题数据
      dashboardDataOption: [],
      openDetail: false,
      openDateDetail: false,
      //看板信息
      formData: {},
      //指标块设置时间信息
      formDateData: {
        filterCondition: { date: { range: [] } }
      },
      rules: this.$util.rules,
      options: {
        codecfg_dateRangeType: { codeId: 'DATERANGETYPE' }
      },
      //看板名称
      boardName: '',
      //当前看板信息
      AtpresentBoard: {},
      //指标块信息
      formDataBlock: {},
      openBlockDetail: false,
      tenantId: ''
    };
  },
  mounted() {
    window.$this = this;
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.osg.codeoption(() => {
      this.getData().then(data => {
        this.AtpresentBoard = this.$util.deepCopy(data);
        this.layout = this.AtpresentBoard.reports ? this.AtpresentBoard.reports : [];
        this.boardName = this.AtpresentBoard._id;
        this.$nextTick(() => {
          this.renderCharts(this.layout);
          this.dashboardChange();
        });
      });
    });
  },
  methods: {
    doDataSave() {
      this.formDataBlock.filterCondition = this.formDateData.filterCondition;
      // var item = { report: this.formDataBlock };
      // eval(this.formDataBlock.jsPart);
      this.doBlockSave();
    },
    doInit() {
      this.openDateDetail = false;
      this.openDetail = false;
      this.formData = {};
      this.formDataBlock = {};
      this.formData.isEdit = false;
      this.openBlockDetail = false;
      this.formDateData = {
        filterCondition: { date: { range: [] } }
      };
    },
    getData() {
      return new Promise(resolve => {
        let params = {
          // "regex:address|string#or": this.searchValue
          'ne:exts.type|integer#and': 2
        };
        this.osg.ajax(
          'biz/dashboard/query.do',
          params,
          res => {
            let dashboardsChoose = JSON.parse(sessionStorage.getItem('dashboardsChoose'));
            var filterArr = [];
            if (dashboardsChoose) {
              filterArr = res.data.filter(item => dashboardsChoose.some(el => el._id === item._id));
            }
            this.dashboardDataOption = [
              {
                label: '最近浏览',
                options: filterArr
              },
              { label: '全部看板', options: res.data }
            ];
            this.dashboardData = res.data;

            this.doInit();

            if (sessionStorage.getItem('dashboardsChoose')) {
              resolve(JSON.parse(sessionStorage.getItem('dashboardsChoose'))[0]);
            } else {
              resolve(res.data[0]);
            }
          },
          { noload: true }
        );
      });
    },
    doSave() {
      return new Promise(resolve => {
        if (!this.formData.isEdit) {
          this.formData.reports = [];
          this.formData.sourceId = 0;
        }
        if (this.tenantId != 0 && this.formData.tenantId == 0) {
          this.formData.sourceId = this.formData._id;
          delete this.formData._id;
        }
        // console.log(this.formData);
        delete this.formData.isEdit;
        this.osg.ajax(
          'biz/dashboard/upsert.do',
          { dashboard: JSON.stringify(this.formData) },
          res => {
            this.AtpresentBoard = this.$util.deepCopy(res.data);
            this.layout = this.$util.deepCopy(this.AtpresentBoard.reports);
            this.boardName = this.AtpresentBoard._id;

            let dashboardsChoose = JSON.parse(sessionStorage.getItem('dashboardsChoose'));
            if (this.AtpresentBoard && dashboardsChoose) {
              dashboardsChoose = dashboardsChoose.filter(
                item => item._id != this.AtpresentBoard._id
              );
              dashboardsChoose.unshift(this.AtpresentBoard);
              sessionStorage.setItem('dashboardsChoose', JSON.stringify(dashboardsChoose));
              this.getData().then(data => {
                this.AtpresentBoard = this.$util.deepCopy(data);
                this.layout = this.AtpresentBoard.reports;
                this.boardName = this.AtpresentBoard._id;
                this.$nextTick(() => {
                  this.renderCharts(this.layout);
                });
              });
            }
            resolve();
          },
          { noload: true }
        );
      });
    },
    //设定-预览按钮
    setting(item) {
      this.openDateDetail = true;
      this.formDataBlock = item.report;
      this.formDateData = item.report;
      this.$nextTick(() => {
        this.reverseFilter(); //反显过滤器
      });
    },
    dashboardChange() {
      let newDashboardData = this.dashboardData.filter(item => item._id == this.boardName)[0];
      if (newDashboardData) {
        this.layout = newDashboardData.reports;
        this.AtpresentBoard = newDashboardData;
        if (sessionStorage.getItem('dashboardsChoose')) {
          let dashboardsChoose = JSON.parse(sessionStorage.getItem('dashboardsChoose'));
          dashboardsChoose = dashboardsChoose.filter(item => item._id != newDashboardData._id);
          dashboardsChoose.unshift(newDashboardData);
          sessionStorage.setItem('dashboardsChoose', JSON.stringify(dashboardsChoose));
        } else {
          let sessionArr = [newDashboardData];
          sessionStorage.setItem('dashboardsChoose', JSON.stringify(sessionArr));
        }
        this.dashboardDataOption[0].options = JSON.parse(
          sessionStorage.getItem('dashboardsChoose')
        );
        this.getData().then(data => {
          this.AtpresentBoard = this.$util.deepCopy(data);
          this.layout = this.AtpresentBoard.reports;
          this.boardName = this.AtpresentBoard._id;
          this.$nextTick(() => {
            this.renderCharts(this.layout);
          });
        });
      }
    },
    //看板操作按钮
    commandClick(command) {
      if (command == 'edit') {
        this.openDetail = true;
        this.formData = this.AtpresentBoard;
        this.formData.isEdit = true;
      } else if (command == 'copy') {
        this.osg.confirm(`是否确认克隆"${this.AtpresentBoard.boardName}"？`, () => {
          this.formData = {
            isEdit: true,
            boardName: this.AtpresentBoard.boardName + '-克隆',
            describe: this.AtpresentBoard.describe,
            reports: this.AtpresentBoard.reports,
            sourceId: '0'
          };
          this.doSave().then(() => {
            this.osg.toast('克隆成功');
          });
        });
      } else if (command == 'delete') {
        this.osg.confirm(`是否确认删除"${this.AtpresentBoard.boardName}"？`, () => {
          this.osg.ajax('biz/dashboard/remove.do', { id: this.AtpresentBoard._id }, res => {
            //删除sessionStorage
            let dashboardsChoose = JSON.parse(sessionStorage.getItem('dashboardsChoose'));
            dashboardsChoose = dashboardsChoose.filter(item => item._id != this.AtpresentBoard._id);
            sessionStorage.setItem('dashboardsChoose', JSON.stringify(dashboardsChoose));
            this.getData().then(data => {
              this.AtpresentBoard = this.$util.deepCopy(data);
              this.layout = this.AtpresentBoard.reports;
              this.boardName = this.AtpresentBoard._id;
              this.$nextTick(() => {
                this.renderCharts(this.layout);
              });
              this.osg.toast('删除成功');
            });
          });
        });
      }
    },
    // 指标块操作按钮
    commandBlockClick(command) {
      if (command.val == 'BlockEdit') {
        this.openBlockDetail = true;
        this.formDataBlock = command.data;
      } else if (command.val == 'BlockRemove') {
        this.osg.confirm(`是否确定从看板中删除"${command.data.report.title}"？`, () => {
          this.AtpresentBoard.reports = this.AtpresentBoard.reports.filter(
            item => item.report._id != command.data.report._id
          );
          this.formData = this.$util.deepCopy(this.AtpresentBoard);
          this.formData.isEdit = true;
          this.doSave().then(() => {
            this.osg.toast('保存成功');
          });
        });
      }
    },
    //反显过滤器
    reverseFilter() {
      if (this.formDataBlock.config && this.$util.isJson(this.formDataBlock.config)) {
        let config = JSON.parse(this.formDataBlock.config);
        // console.log(config);
        //指标块有过滤条件才会反显
        if (config.plans) {
          $that.preFilter = JSON.parse(config.plans);
          //window.sessionStorage.removeItem('filters'); //清空session 每次getData都有影响
          $that.defaultFilterShow = false; //隐藏默认过滤列表
          $that.filterSearchShow = false; //隐藏过滤字段搜索列表
          $that.editFilterShow = false; //隐藏编辑过滤器列表
          $that.filterApplyShow = true; //显示预保留过滤器列表
          console.log($that.preFilter);
        }
      }
    },
    //过滤器存储反显
    noteShowValue(config) {
      if (this.$util.isJson(config)) {
        let data = JSON.parse(config);
        return data.plans && this.$util.isJson(data.plans)
          ? Array.isArray(JSON.parse(data.plans)) &&
              JSON.parse(data.plans)
                .map(item => item.note)
                .join(', ')
          : '';
      }
      return '';
    },
    //时间范围修改;
    reportDateChange(val) {
      //   console.log(val, this.formDateData.filterCondition.date);
      //   //   console.log(this.formDateData.filterCondition.date.type);
      //   if (this.formDataBlock.config && this.$util.isJson(this.formDataBlock.config)) {
      //     // let date = this.formDateData.filterCondition.date;
      //     let dateObj = this.date.dateRange(val);
      //     //   this.formDataBlock.config = JSON.parse(this.formDataBlock.config);
      //     //   this.formDataBlock.config.params = this.$util.deepCopy(params); //过滤器参数加完，替换旧的
      //     //   this.formDataBlock.config = JSON.stringify(this.formDataBlock.config);
      //     // this.formDataBlock.filterCondition.date=dateObj
      //     this.$set(this.formDataBlock.filterCondition, 'date', dateObj);
      //     console.log(this.formDataBlock);
      //   }
      if (this.formDataBlock.config && this.$util.isJson(this.formDataBlock.config)) {
        this.$refs.cReportLit.getData();
      }
      //   console.log();
    },
    doBlockSave() {
      //   console.log($that.filter.preFilter);
      //   return;
      //往报表配置字段添加过滤器参数
      if (this.formDataBlock.config && this.$util.isJson(this.formDataBlock.config)) {
        let config = this.$util.deepCopy(JSON.parse(this.formDataBlock.config)); //报表配置
        let params = this.$util.deepCopy(config.fixedParams); //报表参数,这里取报表的固定参数
        let colName = config.colName; //报表的动态表单名称
        if ($that) $that.getParams(params, colName); //过滤器参数添加至参数
        this.formDataBlock.config = JSON.parse(this.formDataBlock.config);
        // debugger;
        this.formDataBlock.config.plans = JSON.stringify($that.preFilter);
        this.formDataBlock.config.params = this.$util.deepCopy(params); //过滤器参数加完，替换旧的
        this.formDataBlock.config = JSON.stringify(this.formDataBlock.config);
        this.viewReload();
        console.log(this.formDataBlock);
      }
      //将指标块替换为新改动的指标库
      this.AtpresentBoard.reports.map(item => {
        if (item.report._id == this.formDataBlock._id) {
          item.report = this.formDataBlock;
        }
      });
      this.formData = this.$util.deepCopy(this.AtpresentBoard);
      this.formData.isEdit = true;
      this.doSave().then(() => {
        this.osg.toast('保存成功');
      });
    },
    layoutUpdatedEvent(newLayout) {
      // debugger;
      this.AtpresentBoard.reports = newLayout;
      // this.formData = this.$util.deepCopy(this.AtpresentBoard);
      // this.formData.isEdit = true;
      // this.doSave();
    },
    layoutMoved() {
      this.formData = this.$util.deepCopy(this.AtpresentBoard);
      this.formData.isEdit = true;
      this.doSave();
    },
    //渲染报表块的图表
    renderCharts(layout) {
      this.globalDate = this.globalDate ? this.globalDate : [];
      if (layout)
        for (let item of layout) {
          if (item.report.jsPart) {
            try {
              let obj = item.report.jsPart;
              eval(obj);
            } catch (e) {
              console.log('报错看板：' + item.report.title);
              console.log('报错内容：' + e.toString());
              console.log('报错看板对象：', item.report);
              console.log('-------------------');
            }
          }
        }
    }
  },
  filters: {
    dateRange(val) {
      let data = $this.options.dateRangeType.filter(item => item.value == val.date.type)[0];
      if (data) {
        if (data.value == 'custom') {
          return (
            ((val.date.range && val.date.range[0]) || '不限') +
            ' ~ ' +
            ((val.date.range && val.date.range[1]) || '不限')
          );
        } else {
          return data.label;
        }
      }
    }
  },
  watch: {
    globalDate() {
      if (!this.globalDate) {
        this.globalDate = [];
      }
    },
    'formDateData.filterCondition.date.range'() {
      if (!this.formDateData.filterCondition.date.range) {
        this.formDateData.filterCondition.date.range = [];
      }
    }
  }
};
</script>

<style scoped>
.Dashboards {
  margin: -10px -20px;
  height: calc(100% + 30px);
  background: #f5f8fa;
}
.filter-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 0px 22px;
  padding-top: 20px;
  box-sizing: border-box;
}
/*.isHover-link:hover {
  color: #409eff !important;
  text-decoration: underline;
  cursor: pointer;
}*/
.head-box {
  background: #fff;
  padding: 0 10px;
  border-top: 1px solid #dfe3eb;
}
.reports {
  overflow-y: auto;
  padding-bottom: 300px;
}
.vue-grid-item {
  border-radius: 3px;
  background-color: #fff;
  cursor: grab !important;
  transition: box-shadow 0.15s ease-in-out;
}
.vue-grid-item:hover {
  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);
}
.filter-inner {
  /* max-width: 250px;
  width: 250px; */
  display: flex;
}
.demonstration {
  margin: 5px 15px 10px 0;
}
.el-select {
  width: 100%;
}
.iBlock {
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.iBlock-head {
  margin-bottom: 24px;
}
.iBlock-contents {
  flex: 1;
}
.iBlock-head-title {
  padding-bottom: 24px;
  color: #33475b;
  font-weight: 400;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
}
.dropdown-block {
  /* display: none; */
}
.vue-grid-layout :hover .dropdown-block {
  display: block;
}
.search-wrapper {
  max-width: 400px;
  width: 400px;
}
.el-select-dropdown__item.selected {
  /*font-weight: inherit;*/
}
.Dashboards-title >>> .el-input__inner {
  border: 0 !important;
}
.Dashboards-title >>> .el-input__suffix {
  /* min-width: 150px; */
}
.report-html {
  height: 100%;
}
#Dashboards >>> .el-dialog {
  width: 80vw;
  min-width: 400px;
  max-width: 95%;
  max-height: 80vh;
  margin: 10vh auto 10vh !important;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}
.iBlock-head-filter {
  display: flex;
  justify-content: space-between;
}
</style>
